import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "wrap_loader"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"loader_wrap\"><div class=\"loader\"><div class=\"inner one\"></div><div class=\"inner two\"></div><div class=\"inner three\"></div></div></div>", 1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_ctx.show)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2
      ]))
    : _createCommentVNode("", true)
}